import PropTypes from 'prop-types';
import { FormProvider as Form } from 'react-hook-form';

export default function FormProviderComponent({ children, onSubmit, methods }) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}

FormProviderComponent.propTypes = {
  children: PropTypes.node,
  methods: PropTypes.object,
  onSubmit: PropTypes.func,
};